import { ToastProgrammatic as Toast } from 'buefy'

class Utils {
	constructor(isDebug) {
		this.isDebug = isDebug;
	}

	log(str) {
		if (this.isDebug === 'true') {
			console.log(str);
		}
	}

	_toast(msg, type) {
		Toast.open({
			duration: 3000,
			position: 'is-top',
			type: type,
			message: msg,
		});
	}

	toastSuccess(msg) {
		this._toast(msg, 'is-success');
	}

	toastError(msg) {
		this._toast(msg, 'is-danger');
	}

	toCamelCase(str) {
		return str.split('_').map(function(word,index){
			if (index === 0) {
				return word.toLowerCase();
			}
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
		}).join('');
	}

	zeroPadding(num, digit) {
		let pad = '';
		for (let i = 0; i < digit; i++) {
			pad += '0';
		}
		return (pad + num).slice(-digit);
	}

	hasError(errors, key) {
		return errors[key] !== '';
	}

	extractFileExtension(fileName) {
		let tmp = fileName.split('.');
		return tmp[tmp.length - 1];
	}

	createCsvContents(data, delim = ',') {
		let csv = '\ufeff';

		for (let row in data) {
			let line = '';
			for (let col in data[row]) {
				line += data[row][col] + delim;
			}
			line = line.slice(0, -1);
			csv += line + '\n';
		}

		return csv;
	}

	toggleLoading() {
		document.querySelector('.loader').classList.toggle('is-open')
		document.querySelector('.overlay').classList.toggle('is-open')
	}
}

export default Utils
